<template>
  <van-pull-refresh
    v-model="refreshing"
    class="page-pull-refresh"
    @refresh="onRefresh"
  >
    <div class="passage-record">
    <!--section class="page-hero">
      <div class="page-hero__copy">
        <span class="page-hero__eyebrow">通行记录</span>
        <h2>人员上下船通行查询</h2>
        <p>聚合日期、设备和证件号码筛选，让手机端快速定位，桌面端同时对比更多记录。</p>
      </div>
      <div class="page-hero__meta">
        <span class="meta-pill">总记录 {{ allRecords.length }}</span>
        <span class="meta-pill meta-pill--soft">当前筛选 {{ records.length }}</span>
      </div>
    </section-->

    <div class="filter-section">
      <van-search
        v-model="filters.docNo"
        :placeholder="$tText('passRecord.search.docNoPlaceholder', '输入证件号码搜索')"
        @search="onSearch"
        @clear="onClear"
        show-action
      >
        <template #action>
          <div @click="onSearch">{{ $tText('passRecord.search.button', '搜索') }}</div>
        </template>
      </van-search>
      <!-- 日期范围选择器 -->
      <div class="date-range-display">
        <van-field
          readonly
          clickable
          :label="$tText('passRecord.filter.dateLabel', '日期范围')"
          :value="formatDateRange()"
          :placeholder="$tText('passRecord.filter.datePlaceholder', '选择日期范围')"
          @click="openDateRangePicker"
          style="flex:1"
        />
        <span v-if="filters.dateRange.length" class="clear-date" @click="resetDateRange">重置</span>
      </div>
      <!-- 设备选择器 -->
      <div class="device-selector">
        <van-field
          readonly
          clickable
          :label="$tText('passRecord.filter.deviceLabel', '闸口设备')"
          :value="selectedDeviceName"
          :placeholder="$tText('passRecord.filter.devicePlaceholder', '选择闸口设备')"
          @click="openDevicePicker"
          style="flex:1"
        />
        <span v-if="filters.deviceId" class="clear-device" @click="resetDeviceFilter">重置</span>
      </div>
      <van-popup v-model="showDatePicker" position="bottom" @close="onDateRangePopupClose">
        <div style="padding: 16px;">
          <div style="margin-bottom: 8px;">{{ $tText('passRecord.datePicker.startLabel', '开始日期') }}</div>
          <van-datetime-picker
            v-model="tempStartDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            title="选择开始日期"
            :show-toolbar="false"
          />
          <div style="margin: 16px 0 8px;">{{ $tText('passRecord.datePicker.endLabel', '结束日期') }}</div>
          <van-datetime-picker
            v-model="tempEndDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            title="选择结束日期"
            :show-toolbar="false"
          />
          <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px;">
            <van-button size="small" @click="showDatePicker = false">{{ $tText('passRecord.datePicker.cancel', '取消') }}</van-button>
            <van-button size="small" type="primary" @click="onDateRangeConfirm">{{ $tText('passRecord.datePicker.confirm', '确定') }}</van-button>
          </div>
        </div>
      </van-popup>
      <!-- 设备选择弹窗 -->
      <van-popup v-model="showDevicePicker" position="bottom" :style="{ height: '70%' }" round>
        <div class="popup-header">
          <h3>{{ $tText('passRecord.devicePopup.title', '选择梯口设备') }}</h3>
          <van-icon name="cross" @click="showDevicePicker = false" />
        </div>
        
        <div class="device-list">
                    <div class="device-selection">
            <h4>{{ $tText('passRecord.devicePopup.availableListTitle', '可用梯口设备列表') }}</h4>
            <van-loading v-if="devicesLoading" type="spinner" color="#667eea" class="loading-center">
              {{ $tText('passRecord.devicePopup.loading', '加载设备中...') }}
            </van-loading>
            <van-radio-group v-model="tempSelectedDevice" v-else>
              <van-cell-group>
                <van-cell
                  v-for="device in availableDevices"
                  :key="device.id"
                  :title="device.deviceName"
                  :label="`设备编号: ${device.deviceSN} | 所属码头: ${getPortName(device.portCode)}`"
                  clickable
                  @click="tempSelectedDevice = device.id"
                >
                  <template #icon>
                    <van-icon name="cluster-o" class="device-icon" />
                  </template>
                  <template #right-icon>
                    <van-radio :name="device.id" />
                  </template>
                  <template #extra>
                    <van-tag :type="device.isOnline ? 'success' : 'warning'" size="small">
                      {{ device.isOnline ? '在线' : '离线' }}
                    </van-tag>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
            <van-empty
              v-if="!devicesLoading && availableDevices.length === 0"
              :description="$tText('passRecord.devicePopup.empty', '暂无可用梯口设备')"
            >
              <template #image>
                <svg width="120" height="80" viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="60" cy="40" r="20" fill="none" stroke="#d9d9d9" stroke-width="3"/>
                  <path d="M75 55 L85 65" stroke="#d9d9d9" stroke-width="3" stroke-linecap="round"/>
                  <circle cx="60" cy="40" r="12" fill="none" stroke="#d9d9d9" stroke-width="1.5" stroke-dasharray="3 3"/>
                </svg>
              </template>
            </van-empty>
          </div>

          <div class="binding-actions">
            <van-button
              type="primary"
              block
              round
              :disabled="!tempSelectedDevice"
              @click="onDeviceConfirm"
            >
              {{ $tText('passRecord.devicePopup.confirm', '确定选择') }}
            </van-button>
          </div>
        </div>
      </van-popup>
    </div>

    <div class="stats-section">
      <div class="stat-item" :class="{active: activeDirection === -99}" @click="resetDirectionStat">
        <span class="stat-label">{{ $tText('passRecord.stat.total', '总记录数') }}</span>
        <span class="stat-value">{{ totalCount }}</span>
      </div>
      <div class="stat-item" :class="{active: activeDirection === 1}" @click="onDirectionStatClick(1)">
        <span class="stat-label">{{ $tText('passRecord.stat.boardCount', '入场数') }}</span>
        <span class="stat-value">{{ summaryBoardCount }}</span>
      </div>
      <div class="stat-item" :class="{active: activeDirection === 2}" @click="onDirectionStatClick(2)">
        <span class="stat-label">{{ $tText('passRecord.stat.leaveCount', '离场数') }}</span>
        <span class="stat-value">{{ summaryLeaveCount }}</span>
      </div>
    </div>

    <div class="record-list-section">
      <van-loading v-if="loading" type="spinner" color="#667eea" class="loading-center">加载中...</van-loading>
      <van-list
        v-else
        v-model="loadingMore"
        :finished="finished"
        :immediate-check="true"
        :offset="120"
        finished-text="没有更多了"
        @load="onLoadMore"
        class="record-van-list"
      >
        <div class="record-list">
          <van-card
            v-for="record in records"
            :key="record.id"
            class="record-card"
            @click="showDetail(record)"
          >
            <template #title>
              <div class="record-header">
                <div class="main-info">
                  <span class="tk-name">{{ record.bindingTK }}</span>
                  <span class="direction">
                    <van-icon :name="record.direction === 1 ? 'arrow-up' : 'arrow-down'" :color="record.direction === 1 ? '#07c160' : '#ee0a24'" />
                    {{ getDirectionText(record.direction) }}
                  </span>
                </div>
                <div class="pass-time">{{ formatPassTime(record.passTime) }}</div>
              </div>
            </template>
            <template #desc>
              <div class="record-content compact">
                  <div class="record-photo">
                    <div class="photo-container">
                      <img
                        v-if="record.thumbnailPhotoUrl || record.originalPhotoUrl"
                        :src="record.thumbnailPhotoUrl || record.originalPhotoUrl"
                        :alt="record.name"
                        class="person-photo"
                        @click.stop="previewPhoto(record.thumbnailPhotoUrl || record.originalPhotoUrl)"
                      />
                      <div v-else class="no-photo">无照片</div>
                    </div>
                </div>
                <div class="record-details side-detail">
                  <div class="detail-row"><span class="label">证件号码：</span><span class="value">{{ record.docNo }}</span></div>
                  <div class="detail-row"><span class="label">有效期：</span><span class="value">{{ formatDateRangeText(record.docEffective, record.docExpire) }}</span></div>
                  <div class="detail-row"><span class="label">码头名称：</span><span class="value">{{ getPortName(record.portCode) }}</span></div>
                </div>
                <div v-if="record.video" class="video-action">
                  <van-button 
                    size="small" 
                    type="primary" 
                    round 
                    @click.stop="playVideo(record.video)"
                    class="video-play-btn"
                  >
                    <van-icon name="play-circle-o" />
                  </van-button>
                </div>
              </div>
            </template>
            <template #footer>
              <div class="record-footer compact">
                <span class="meta-item">
                  <van-icon name="user-o" />
                  {{ getPersonTypeText(record.personType) }}
                </span>
                <span class="meta-item type">
                  <van-tag v-if="record.keyPerson === 1" type="danger" size="small">重点人员</van-tag>
                  <van-tag v-else type="default" size="small">普通人员</van-tag>
                </span>
                <span class="meta-item">
                  <van-icon name="manager-o" />
                  {{ record.assistanUserName || '-' }}
                </span>
              </div>
            </template>
          </van-card>
        </div>
      </van-list>
      <van-empty v-if="!loading && records.length === 0" :description="$tText('passRecord.empty', '暂无通行记录')">
        <template #image>
          <svg width="120" height="80" viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="60" cy="40" r="20" fill="none" stroke="#d9d9d9" stroke-width="3"/>
            <path d="M75 55 L85 65" stroke="#d9d9d9" stroke-width="3" stroke-linecap="round"/>
            <circle cx="60" cy="40" r="12" fill="none" stroke="#d9d9d9" stroke-width="1.5" stroke-dasharray="3 3"/>
          </svg>
        </template>
      </van-empty>

      <!-- 详情弹窗 -->
      <van-popup v-model="showDetailPopup" position="bottom" :style="{ height: '50vh', minWidth: '90vw', borderRadius: '16px', overflow: 'hidden' }" round>
        <div class="detail-popup scrollable-detail">
          <div class="detail-title">{{ $tText('passRecord.detail.title', '通行详情') }}</div>
          <div class="detail-row"><span class="label">通行ID：</span><span class="value">{{ detailRecord.id }}</span></div>
          <div class="detail-row"><span class="label">通行方向：</span><span class="value">{{ getDirectionText(detailRecord.direction) }}</span></div>
          <div class="detail-row"><span class="label">姓名：</span><span class="value">{{ detailRecord.name }}</span></div>
          <div class="detail-row"><span class="label">证件号码：</span><span class="value">{{ detailRecord.docNo }}</span></div>
          <div class="detail-row"><span class="label">有效期：</span><span class="value">{{ formatDateRangeText(detailRecord.docEffective, detailRecord.docExpire) }}</span></div>
          <div class="detail-row"><span class="label">人员类型：</span><span class="value">{{ getPersonTypeText(detailRecord.personType)  }}</span></div>
          <div class="detail-row"><span class="label">重点人员:</span><span class="value">{{ detailRecord.keyPerson===1?'是':'否' }}</span></div>
          <div class="detail-row"><span class="label">协管员:</span><span class="value">{{ detailRecord.assistanUserName}}</span></div>
          <div class="detail-row"><span class="label">码头名称：</span><span class="value">{{ getPortName(detailRecord.portCode) }}</span></div>
        </div>
      </van-popup>

    </div>
    
    <!-- 照片预览 -->
    <van-image-preview
      v-model="showPhotoPreview"
      :images="previewImages"
      :start-position="previewIndex"
      :closeable="true"
      close-icon="cross"
      close-icon-position="top-right"
    />
    
    <!-- 视频播放弹窗 -->
    <van-popup v-model="showVideoPlayer" position="center" :style="{ width: '90vw', height: '60vh', borderRadius: '12px' }" round>
      <div class="video-player-container">
        <div class="video-header">
          <h3>通行视频</h3>
          <van-icon name="cross" @click="showVideoPlayer = false" />
        </div>
        <div class="video-content">
          <video
            v-if="currentVideoUrl"
            :src="currentVideoUrl"
            controls
            autoplay
            class="video-player"
            @error="onVideoError"
          >
            您的浏览器不支持视频播放
          </video>
        </div>
      </div>
    </van-popup>
    </div>
  </van-pull-refresh>
</template>

<script>
import axios from '@/utils/request'
import { fetchMultiDic, default as globalDic } from '@/utils/dic'

export default {
  name: 'PassageRecord',
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return {
      filters: {
        portCode: '',
        docNo: '',
        personType: -99,
        keyPerson: -99,
        name: '',
        direction: -99,
        bindingTK: '',
        deviceId: '', // 设备ID
        deviceName: '', // 设备名称
        dateRange: [today, today]
      },
      loading: false,
      refreshing: false,
      loadingMore: false,
      finished: false,
      pageIndex: 1,
      pageSize: 20,
      records: [],
      totalCount: 0,
      summaryBoardCount: 0,
      summaryLeaveCount: 0,
      showDatePicker: false,
      tempStartDate: new Date(today),
      tempEndDate: new Date(today),
      minDate: new Date(2000, 0, 1),
      maxDate: now,
      showPhotoPreview: false,
      previewImages: [],
      previewIndex: 0,
      defaultPhoto: 'https://img.yzcdn.cn/vant/cat.jpeg',
      showDetailPopup: false,
      detailRecord: {},
      activeDirection: -99,
      // 设备选择相关
      showDevicePicker: false,
      availableDevices: [],
      devicesLoading: false,
      tempSelectedDevice: '',
      // 视频播放相关
      showVideoPlayer: false,
      currentVideoUrl: '',
    }
  },
  computed: {
    selectedDeviceName() {
      return this.filters.deviceName || '';
    }
  },
  methods: {
    async fetchRecords({ reset = false } = {}) {
      if (reset) {
        this.pageIndex = 1;
        this.finished = false;
        this.records = [];
        this.loading = true;
      } else if (this.finished) {
        return;
      } else {
        this.loadingMore = true;
      }

      try {
        const params = {
          portCode: this.filters.portCode,
          docNo: this.filters.docNo,
          personType: this.filters.personType,
          keyPerson: this.filters.keyPerson,
          name: this.filters.name,
          direction: this.filters.direction,
          bindingTK: this.filters.deviceName, // 使用设备名称作为bindingTK参数
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        };
        if (this.filters.dateRange.length === 2) {
          const getDayStartISOString = date => {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);
            d.setHours(d.getHours() + 8);
            return d.toISOString();
          };
          const getDayEndISOString = date => {
            const d = new Date(date);
            d.setHours(23, 59, 59, 999);
            d.setHours(d.getHours() + 8);
            return d.toISOString();
          };
          params.StartTime = getDayStartISOString(this.filters.dateRange[0]);
          params.EndTime = getDayEndISOString(this.filters.dateRange[1]);
        }
        const res = await axios.post('/api/PassRecord/Query', params);
        if (res && res.data && res.data.success) {
          const result = res.data.data || {};
          const items = result.items || [];
          this.records = reset ? items : this.records.concat(items);
          this.totalCount = Number(result.totalCount || 0);
          this.summaryBoardCount = Number(result.boardCount || 0);
          this.summaryLeaveCount = Number(result.leaveCount || 0);
          this.finished = !!result.hasMore === false;
          if (items.length > 0) {
            this.pageIndex += 1;
          }
        } else {
          this.$toast.fail(res.data.message || '查询失败');
          if (reset) {
            this.records = [];
            this.totalCount = 0;
            this.summaryBoardCount = 0;
            this.summaryLeaveCount = 0;
          }
          this.finished = true;
        }
      } catch (err) {
        this.$toast.fail('查询失败，请检查网络');
        if (reset) {
          this.records = [];
          this.totalCount = 0;
          this.summaryBoardCount = 0;
          this.summaryLeaveCount = 0;
        }
        this.finished = true;
      } finally {
        this.loading = false;
        this.loadingMore = false;
      }
    },
    onLoadMore() {
      this.fetchRecords();
    },
    async onRefresh() {
      try {
        await this.fetchRecords({ reset: true });
      } finally {
        this.refreshing = false;
      }
    },
    // 获取可用设备列表
    async fetchAvailableDevices() {
      this.devicesLoading = true;
      try {
        // 获取当前用户信息
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        let params = {};
        
        // 如果用户不是超级管理员且有码头限制，则只查询该码头的设备
        if (userInfo.roleID !== 0 && userInfo.portCode) {
          params.portCode = userInfo.portCode;
        }
        
        const res = await axios.post('/api/Device/Query', params);
        if (res && res.data && res.data.success) {
          this.availableDevices = res.data.data || [];
        } else {
          this.$toast.fail(res.data.message || '获取设备列表失败');
          this.availableDevices = [];
        }
      } catch (err) {
        console.error('获取设备列表失败:', err);
        this.$toast.fail('获取设备列表失败，请检查网络连接');
        this.availableDevices = [];
      } finally {
        this.devicesLoading = false;
      }
    },
    // 打开设备选择器
    async openDevicePicker() {
      if (this.availableDevices.length === 0) {
        await this.fetchAvailableDevices();
      }
      this.tempSelectedDevice = this.filters.deviceId;
      this.showDevicePicker = true;
    },
    // 确认设备选择
    onDeviceConfirm() {
      this.filters.deviceId = this.tempSelectedDevice;
      // 根据选中的设备ID获取设备名称
      const selectedDevice = this.availableDevices.find(d => d.id === this.tempSelectedDevice);
      this.filters.deviceName = selectedDevice ? selectedDevice.deviceName : '';
      this.showDevicePicker = false;
      this.fetchRecords({ reset: true });
    },
    // 重置设备过滤
    resetDeviceFilter() {
      this.filters.deviceId = '';
      this.filters.deviceName = '';
      this.tempSelectedDevice = '';
      this.fetchRecords({ reset: true });
    },
    openDateRangePicker() {
      if (this.filters.dateRange.length === 2) {
        this.tempStartDate = new Date(this.filters.dateRange[0]);
        this.tempEndDate = new Date(this.filters.dateRange[1]);
      } else {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        this.tempStartDate = today;
        this.tempEndDate = today;
      }
      this.showDatePicker = true;
    },
    onDateRangeConfirm() {
      // 结束日期不能小于开始日期
      if (this.tempEndDate < this.tempStartDate) {
        this.$toast.fail('结束日期不能早于开始日期');
        return;
      }
      this.filters.dateRange = [this.tempStartDate, this.tempEndDate];
      this.showDatePicker = false;
      this.fetchRecords({ reset: true });
    },
    resetDateRange() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      this.filters.dateRange = [today, today];
      this.tempStartDate = new Date(today);
      this.tempEndDate = new Date(today);
      this.maxDate = now;
      this.fetchRecords({ reset: true });
    },
    getPortName(portCode) {
      if (!portCode) return '';
      if (!globalDic.D_Port || globalDic.D_Port.length === 0) return portCode;
      const port = globalDic.D_Port.find(item => item.code === portCode);
      return port ? port.description : portCode;
    },
    getDirectionText(direction) {
      // 尝试从字典获取方向文字
      if (globalDic.D_Direction && globalDic.D_Direction.length > 0) {
        const directionItem = globalDic.D_Direction.find(item => item.code === direction);
        if (directionItem && directionItem.description) {
          return directionItem.description;
        }
      }
      // 默认映射
      if (direction === 1) return '登轮';
      if (direction === 2) return '离轮';
      return '-';
    },
    getPersonTypeText(type) {
      const personTypeDic = globalDic.D_PersonType || [];
      const found = personTypeDic.find(item => String(item.code) === String(type));
      if (found && found.description) {
        return found.description;
      }

      if (String(type) === '0') return '协管员';
      if (String(type) === '1') return '常备人员';
      if (String(type) === '2') return '临时人员';
      if (String(type) === '3') return '船员';
      return '未知';
    },
    formatPassTime(passTime) {
      if (!passTime) return '-';
      const d = new Date(passTime);
      return d.toLocaleString('zh-CN');
    },
    formatDateRangeText(start, end) {
      if (!start || !end) return '-';
      return `${start} ~ ${end}`;
    },
    onSearch() {
      this.fetchRecords({ reset: true });
    },
    onClear() {
      this.filters.docNo = '';
      this.fetchRecords({ reset: true });
    },
    clearDateRange() {
      this.filters.dateRange = [];
      this.fetchRecords({ reset: true });
    },
    formatDateRange() {
      if (this.filters.dateRange.length === 2) {
        const [start, end] = this.filters.dateRange;
        const format = d => {
          if (!d) return '';
          const date = new Date(d);
          return date.toLocaleDateString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit' });
        };
        return `${format(start)}~${format(end)}`;
      }
      return '';
    },
    previewPhoto(photo) {
      if (!photo) return;
      this.previewImages = [photo];
      this.previewIndex = 0;
      this.showPhotoPreview = true;
    },
    showDetail(record) {
      this.detailRecord = record;
      this.showDetailPopup = true;
    },
    onDateRangePopupClose() {
      // 关闭弹窗时同步选中的日期
      if (this.tempEndDate < this.tempStartDate) {
        this.$toast.fail('结束日期不能早于开始日期');
        return;
      }
      this.filters.dateRange = [this.tempStartDate, this.tempEndDate];
      this.fetchRecords({ reset: true });
    },
    onDirectionStatClick(direction) {
      if (this.activeDirection === direction) {
        this.activeDirection = -99;
      } else {
        this.activeDirection = direction;
      }
      this.filters.direction = this.activeDirection;
      this.fetchRecords({ reset: true });
    },
    resetDirectionStat() {
      if (this.activeDirection === -99 && this.filters.direction === -99) {
        return;
      }
      this.activeDirection = -99;
      this.filters.direction = -99;
      this.fetchRecords({ reset: true });
    },
    // 播放视频
    playVideo(videoUrl) {
      if (!videoUrl) {
        this.$toast.fail('视频链接无效');
        return;
      }
      this.currentVideoUrl = videoUrl;
      this.showVideoPlayer = true;
    },
    // 视频播放错误处理
    onVideoError() {
      this.$toast.fail('视频加载失败，请检查网络连接');
      this.showVideoPlayer = false;
    },
  },
  async mounted() {
    await fetchMultiDic(['D_Port', 'D_Direction', 'D_PersonType']);
    this.fetchRecords({ reset: true });
  }
}
</script>

<style scoped>
.passage-record {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-height: 100%;
}

.page-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 24px;
  border-radius: 28px;
  color: #fff;
  background: linear-gradient(135deg, var(--surface-strong) 0%, var(--brand-500) 65%, #6caeff 100%);
  box-shadow: 0 22px 50px rgba(15, 79, 185, 0.2);
}

.page-hero__copy h2 {
  font-size: 28px;
  line-height: 1.18;
  margin-bottom: 10px;
}

.page-hero__copy p {
  max-width: 680px;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.75;
}

.page-hero__eyebrow {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.page-hero__meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.meta-pill {
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  font-size: 13px;
  font-weight: 700;
}

.meta-pill--soft {
  background: rgba(255, 255, 255, 0.1);
}
.filter-section {
  background: rgba(255, 255, 255, 0.92);
  padding: 10px;
  border: 1px solid rgba(215, 229, 251, 0.96);
  border-radius: 24px;
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.filter-options {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 12px;
}
.date-range-display {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 28px;
}
.date-range-display .van-field {
  flex: 1;
  min-width: 0;
  --van-field-label-width: 48px;
  --van-cell-horizontal-padding: 0px;
  --van-field-input-text-color: var(--text-primary);
}
.date-range-display .van-field :deep(.van-field__label) {
  margin-right: 2px;
}
.date-range-display .van-field :deep(.van-field__value) {
  min-width: 0;
  flex: 1;
  text-align: left;
}
.clear-date {
  color: var(--brand-700);
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  line-height: 1.2;
  flex-shrink: 0;
}
.device-selector {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 28px;
}
.device-selector .van-field {
  flex: 1;
  min-width: 0;
  --van-field-label-width: 48px;
  --van-cell-horizontal-padding: 0px;
  --van-field-input-text-color: var(--text-primary);
}
.device-selector .van-field :deep(.van-field__label) {
  margin-right: 2px;
}
.device-selector .van-field :deep(.van-field__value) {
  min-width: 0;
  flex: 1;
  text-align: left;
}
.clear-device {
  color: var(--brand-700);
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  line-height: 1.2;
  flex-shrink: 0;
}
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #ebedf0;
}

.popup-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}

.device-list {
  padding: 16px;
  height: calc(100% - 60px);
  overflow-y: auto;
}

.device-selection {
  margin-bottom: 24px;
  position: relative;
  min-height: 200px;
}

.device-selection h4 {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
}

.device-selection .loading-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.binding-actions {
  position: sticky;
  bottom: 0;
  background: white;
  padding-top: 16px;
}
.device-icon {
  color: var(--brand-500);
  font-size: 20px;
}
.stats-section {
  display: flex;
  background: rgba(255, 255, 255, 0.92);
  padding: 16px;
  border: 1px solid rgba(215, 229, 251, 0.96);
  border-radius: 24px;
  box-shadow: var(--shadow-card);
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
}
.stat-item {
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  justify-content: flex-start;
  min-width: 90px;
  padding: 12px 14px;
  border-radius: 18px;
}
.stat-label {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.1;
  margin-right: 2px;
}
.stat-value {
  font-size: 20px;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1.1;
  margin-right: 8px;
}
.van-search {
  margin-bottom: 0px;
  min-height: 6px;
  --van-search-padding: 0 0px;
  --van-search-background: #fff;
}
.filter-section :deep(.van-search__content) {
  min-height: 34px;
  padding: 0 10px;
}
.van-search .van-field__control {
  font-size: 14px;
  min-height: 6px;
  padding: 0;
}
.van-field {
  min-height: 6px;
  font-size: 14px;
  padding: 0;
  --van-field-label-width: 60px;
  --van-field-label-font-size: 13px;
  --van-field-input-font-size: 13px;
}
.record-list-section {
  min-height: 120px;
}

.record-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;
}

.record-van-list {
  display: block;
}
.loading-center {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
}
.record-card {
  border-radius: 24px;
  overflow: hidden;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(215, 229, 251, 0.96);
  box-shadow: var(--shadow-card);
}
.record-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.main-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tk-name {
  font-size: 17px;
  font-weight: 700;
  color: var(--text-primary);
}
.direction {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: var(--text-secondary);
}
.pass-time {
  font-size: 12px;
  color: var(--text-muted);
  text-align: right;
}
.record-content {
  display: flex;
  gap: 16px;
  padding: 12px 0;
}
.record-content.compact {
  align-items: center;
  padding: 0;
  position: relative;
}
.record-photo {
  flex-shrink: 0;
}
.photo-container {
  text-align: center;
}
.person-photo {
  width: 72px;
  height: 92px;
  object-fit: cover;
  border-radius: 16px;
  border: 2px solid var(--border-soft);
  cursor: pointer;
  transition: all 0.3s ease;
}
.person-photo:hover {
  border-color: var(--brand-500);
    transform: scale(1.05);
  }
  .photo-label {
  .no-photo {
    width: 72px;
    height: 92px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #999;
    background: #f5f6f8;
    border-radius: 12px;
  }

  font-size: 10px;
  color: #969799;
  margin-top: 4px;
}
.record-footer {
  display: flex;
  justify-content: space-between;
  align-items: center; /* 保证垂直居中 */
  padding-top: 8px;
  border-top: 1px solid #ebedf0;
  min-height: 32px; /* 保证底部高度一致 */
  position: relative; /* 关键 */
}
.record-footer.compact {
  padding: 0;
  border-top: none;
}
.record-meta {
  display: flex;
  gap: 16px;
}
.meta-item {
  display: flex;
  align-items: center; /* 垂直居中 */
  gap: 4px;
  font-size: 12px;
  color: var(--text-secondary);
  min-height: 24px; /* 保证每个标签高度一致 */
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.meta-item.type {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 70px;
  text-align: center;
  z-index: 1;
}
.meta-item.video-btn {
  color: var(--brand-500);
  cursor: pointer;
  transition: color 0.3s ease;
}
.meta-item.video-btn:hover {
  color: var(--brand-700);
}
.video-action {
  position: absolute;
  top: 20%;
  right: 0;
  transform: translateY(-50%);
  z-index: 2;
}
.video-play-btn {
  font-size: 10px;
  padding: 4px 8px;
  height: 28px;
  min-width: 20px;
  box-shadow: 0 8px 18px rgba(22, 119, 255, 0.22);
}
.video-play-btn .van-icon {
  font-size: 14px;
  margin-right: 2px;
}
.video-player-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #000;
}
.video-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
}
.video-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}
.video-header .van-icon {
  cursor: pointer;
  font-size: 20px;
  color: #fff;
}
.video-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.video-player {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
}
.detail-popup {
  padding: 20px;
}
.detail-title {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 20px;
  color: var(--text-primary);
}
.detail-row {
  display: flex;
  margin-bottom: 15px;
}
.detail-row:last-child {
  margin-bottom: 0;
}
.label {
  color: var(--text-secondary);
  font-size: 14px;
  width: 80px;
  flex-shrink: 0;
}
.value {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}
.record-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  padding-left: 10px; /* Adjust as needed */
  min-height: 92px;
  min-width: 0;
  flex: 1;
}
.side-detail .detail-row {
  margin-bottom: 0; /* Remove bottom margin for side detail */
}
.side-detail .detail-row:last-child {
  margin-bottom: 0;
}
.scrollable-detail {
  height: 100%;
  overflow-y: auto;
}
.stat-item.active {
  background: #eef5ff;
  color: var(--brand-500);
  cursor: pointer;
}
.stat-item {
  cursor: pointer;
}

@media (max-width: 767px) {
  .passage-record {
    gap: 14px;
  }

  .page-hero {
    padding: 18px;
    border-radius: 24px;
    flex-direction: column;
  }

  .filter-section {
    padding: 8px 12px;
    gap: 6px;
  }

  .page-hero__copy h2 {
    font-size: 22px;
  }

  .page-hero__meta {
    flex-direction: column;
    align-items: stretch;
  }

  .date-range-display,
  .device-selector {
    gap: 2px;
  }

  .date-range-display .van-field,
  .device-selector .van-field {
    --van-field-label-width: 46px;
  }

  .record-header {
    align-items: flex-start;
  }

  .main-info {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .stats-section {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    align-items: stretch;
  }

  .stat-item {
    min-width: 0;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 10px 6px;
  }

  .stat-label,
  .stat-value {
    margin-right: 0;
  }

  .record-list {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .record-content {
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
  }

  .record-photo {
    width: 72px;
  }

  .person-photo {
    width: 64px;
    height: 82px;
    border-radius: 14px;
  }

  .record-details {
  .no-photo {
    width: 64px;
    height: 82px;
    border-radius: 14px;
  }

    padding-top: 0;
    padding-left: 0;
  }

  .side-detail .detail-row {
    display: flex;
    align-items: flex-start;
    gap: 4px;
  }

  .side-detail .label {
    width: 64px;
    font-size: 12px;
  }

  .side-detail .value {
    min-width: 0;
    font-size: 12px;
    line-height: 1.5;
    word-break: break-all;
  }

  .video-action {
    position: absolute;
    top: 18px;
    right: 0;
    transform: none;
    margin-top: 0;
  }

  .meta-item.type {
    position: static;
    transform: none;
  }
}
</style>
